import LazyLoaderErrorBoundary from '@components/Errors/LazyLoaderErrorBoundary';
export default async function Loadable() {
    const { Feedback } = await import('./index');
    return {
        Component: Feedback,
        ErrorBoundary: LazyLoaderErrorBoundary,
    };
}
